import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdatePublicationCommentListQuery } from "@/queries/query-publication-comment";

export const useRemoveCommentThread = (publicationId: string, onSuccess?: () => void) => {
  const updateCommentList = useUpdatePublicationCommentListQuery(publicationId);

  return useMutationWithErrorHandler(
    async (commentId: string) => {
      // Optimistically remove from cache immediately
      await updateCommentList(commentId, null);

      // Then make the API call
      await getRanaApiV1().PublicationCommentsApi.commentDelete({
        publicationId,
        commentId,
      });
    },
    {
      onSuccess,
    }
  );
};
